function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref = /*#__PURE__*/React.createElement("rect", {
  x: 33,
  y: 33,
  width: 49.0641,
  height: 59.3333,
  rx: 8,
  stroke: "white",
  className: "iconWhiteStroke",
  strokeWidth: 7
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M67.3976 24.6673V24.6673C67.3976 21.1695 64.5621 18.334 61.0643 18.334H26.3335C21.9152 18.334 18.3335 21.9157 18.3335 26.334V71.334C18.3335 74.8318 21.169 77.6673 24.6668 77.6673V77.6673",
  className: "iconWhiteStroke",
  stroke: "white",
  strokeWidth: 7
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M53.0641 10.3333V10.3333C53.0641 6.83553 50.2286 4 46.7308 4H12C7.58172 4 4 7.58172 4 12V57C4 60.4978 6.83553 63.3333 10.3333 63.3333V63.3333",
  className: "iconWhiteStroke",
  stroke: "white",
  strokeWidth: 7
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M61.2833 59.3217V49H54.3244V59.3217H51.6816H44V66.2778H54.3235V76.5972H61.2824V66.2778H69.8736L72.7971 59.3217H61.2833Z",
  fill: "#428EE0",
  className: "iconBlueFill"
});

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 96,
    viewBox: "0 0 86 96",
    fill: "none"
  }, props), _ref, _ref2, _ref3, _ref4);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iODYiIGhlaWdodD0iOTYiIHZpZXdCb3g9IjAgMCA4NiA5NiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjxyZWN0IHg9IjMzIiB5PSIzMyIgd2lkdGg9IjQ5LjA2NDEiIGhlaWdodD0iNTkuMzMzMyIgcng9IjgiIHN0cm9rZT0id2hpdGUiIGNsYXNzPSJpY29uV2hpdGVTdHJva2UiIHN0cm9rZS13aWR0aD0iNyIvPg0KPHBhdGggZD0iTTY3LjM5NzYgMjQuNjY3M1YyNC42NjczQzY3LjM5NzYgMjEuMTY5NSA2NC41NjIxIDE4LjMzNCA2MS4wNjQzIDE4LjMzNEgyNi4zMzM1QzIxLjkxNTIgMTguMzM0IDE4LjMzMzUgMjEuOTE1NyAxOC4zMzM1IDI2LjMzNFY3MS4zMzRDMTguMzMzNSA3NC44MzE4IDIxLjE2OSA3Ny42NjczIDI0LjY2NjggNzcuNjY3M1Y3Ny42NjczIiBjbGFzcz0iaWNvbldoaXRlU3Ryb2tlIiBzdHJva2U9IndoaXRlIiBzdHJva2Utd2lkdGg9IjciLz4NCjxwYXRoIGQ9Ik01My4wNjQxIDEwLjMzMzNWMTAuMzMzM0M1My4wNjQxIDYuODM1NTMgNTAuMjI4NiA0IDQ2LjczMDggNEgxMkM3LjU4MTcyIDQgNCA3LjU4MTcyIDQgMTJWNTdDNCA2MC40OTc4IDYuODM1NTMgNjMuMzMzMyAxMC4zMzMzIDYzLjMzMzNWNjMuMzMzMyIgY2xhc3M9Imljb25XaGl0ZVN0cm9rZSIgc3Ryb2tlPSJ3aGl0ZSIgc3Ryb2tlLXdpZHRoPSI3Ii8+DQo8cGF0aCBkPSJNNjEuMjgzMyA1OS4zMjE3VjQ5SDU0LjMyNDRWNTkuMzIxN0g1MS42ODE2SDQ0VjY2LjI3NzhINTQuMzIzNVY3Ni41OTcySDYxLjI4MjRWNjYuMjc3OEg2OS44NzM2TDcyLjc5NzEgNTkuMzIxN0g2MS4yODMzWiIgZmlsbD0iIzQyOEVFMCIgY2xhc3M9Imljb25CbHVlRmlsbCIvPg0KPC9zdmc+DQo=";
export { SvgComponent as ReactComponent };